import { render } from "./New_PoTextTab.vue?vue&type=template&id=01ca0a1a&scoped=true"
import script from "./New_PoTextTab.vue?vue&type=script&lang=js"
export * from "./New_PoTextTab.vue?vue&type=script&lang=js"

import "./New_PoTextTab.vue?vue&type=style&index=0&id=01ca0a1a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01ca0a1a"]])

export default __exports__